import { useState, useEffect } from "react";
import Wallet from './components/wallet/Wallet'
import Search from './components/search/Search'
import './App.css';
import LoadingIndicator from "./components/loading/LoadingIndicator";
import styled, {ThemeProvider} from "styled-components";
import {GlobalStyles} from './theme/globalStyles'
import {lightTheme, darkTheme} from './theme/Themes'



function App() {
  const [walletAddress, setWalletAddress] = useState('')
  const [theme, setTheme] = useState('light')
  const [checked, setChecked] = useState(false);

  const themeToggler = (nextChecked:any) => {
    try{
      localStorage.removeItem('nextChecked')
      setChecked(nextChecked);
      localStorage.setItem('nextChecked', nextChecked)
      localStorage.removeItem('Theme')
      theme === 'light' ? setTheme('dark') : setTheme('light')
      if(theme === 'light'){
        localStorage.setItem('Theme', 'dark')
      } else if (theme === 'dark'){
        localStorage.setItem('Theme', 'light')
      }
      
    }catch(err){
      console.log(err)
    }

  }
  
  useEffect(() => {
    var nextCheckedFromLocalStorage:any = localStorage.getItem('nextChecked')
    try{
      if(nextCheckedFromLocalStorage){
        return setChecked(nextCheckedFromLocalStorage)
      }
      else{
        return
      }
    }catch(err){
      console.log(err)
    }

  }, [])


  useEffect(() => {
    var themeFromLocalStorage:any = localStorage.getItem('Theme')
    if(themeFromLocalStorage){
      
      return setTheme(themeFromLocalStorage)
    }
    else{
      return
    }
  }, [])

  useEffect(() => {
    var walletFromLocalStorage:any = localStorage.getItem('WalletAddress')
    if(walletFromLocalStorage){
      return setWalletAddress(walletFromLocalStorage)
    }
    else{
      return
    }
  }, [])

  return (
    <ThemeProvider theme = {theme === 'light' ? lightTheme : darkTheme}>
      <GlobalStyles />
      {/* <button onClick={themeToggler}>Theme</button> */}

      <StyledApp className="App">
        <Search theme={theme} checked={checked} themeToggler={themeToggler} walletAddress={walletAddress} setWalletAddress={setWalletAddress}/>
        <LoadingIndicator />
        {walletAddress === '' ? <p>Enter Wallet Address to Search</p> : <Wallet theme={theme} />}
        <StyledDonation>
          <StyledPhrase>Want to support future developments?</StyledPhrase>
          <p>BSC: 0x9F5Dbe074fece38122559aCF226ECb910B64B6C5</p>
        </StyledDonation>
      </StyledApp>
    </ThemeProvider>
  );
}

const StyledDonation = styled.div`
  width: 100%;
  font-size:1rem;
  margin-top:5%;
  border-top:2px solid black;
  align-self:flex-end;
  @media(max-width:750px){
  font-size:.8rem;
}
`
const StyledPhrase = styled.p`
  margin-top:2%
`

const StyledApp = styled.div`
margin-top:1%;
margin-bottom:5%;
display:flex;
flex-direction:column;
min-height: 100vh;
font-size:1.5rem;
@media(max-width:750px){
  font-size:1rem;
}
`
export default App;
